import { Component, OnInit } from '@angular/core';
import { GlobalConstants, Mail } from '../../common/classes';
import { MailService } from '../../common/services/mail.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {
 
  contactName: string;
  contactCompany: string;
  contactPhone: string;
  contactEmail: string;
  contactAddress: string;
  contactReferral: string;
  contactProject: string;
  contactDue: string;
  contactDetails: string;

  submitError = false;
  submitMsg: string;

  mailSent = false;

  constructor(
    private mailService: MailService
  ) { }

  ngOnInit(): void {
    this.contactReferral = "Where did you hear about us?";    
  }

  submitMessage() {
    this.submitError = false;
    this.submitMsg = '';

    let msgBody = '<h1>Website Contact Request</h1>';
    (this.contactName) ? msgBody += '<p>Name: ' + this.contactName + '</p>' : this.submitError = true;
    (this.contactCompany) ? msgBody += '<p>Company: ' + this.contactCompany + '</p>' : msgBody += '';
    (this.contactPhone) ? msgBody += '<p>Phone: ' + this.contactPhone + '</p>' : this.submitError = true;
    (this.contactEmail) ? msgBody += '<p>Email: ' + this.contactEmail + '</p>' : this.submitError = true;
    (this.contactAddress) ? msgBody += '<p>Address: ' + this.contactAddress + '</p>' : this.submitError = true;
    (this.contactReferral) ? msgBody += '<p>Name: ' + this.contactReferral + '</p>' : msgBody += '';
    (this.contactProject) ? msgBody += '<p>Project: ' + this.contactProject + '</p>' : msgBody += '';
    (this.contactDue) ? msgBody += '<p>Due Date: ' + this.contactDue + '</p>' : msgBody += '';
    (this.contactDetails) ? msgBody += '<p>Details: ' + this.contactDetails + '</p>' : msgBody += '';

    if (this.submitError === false) {
      this.sendEmail(msgBody);
      this.submitMsg = 'Thank you for getting in touch. We will reach out to you shortly.';
      this.mailSent = true;
    } else {
      this.submitMsg = 'Please ensure all fields are filled out correctly and try submitting again.';
    }
  }

  private async sendEmail(bodyString) {
    const mailMessage = new Mail();
    mailMessage.type = 'contact';
    mailMessage.name = this.contactName;
    mailMessage.email = this.contactEmail;
    mailMessage.content = bodyString;
    mailMessage.apiKey = GlobalConstants.apiKey;

    const message = await this.mailService.sendMail(mailMessage).toPromise();
  }

}
